import { ReportContext } from '@/app/providers/reportProvider';
import { useTranslations } from 'next-intl';
import { useContext } from 'react';

export default function LicenceTypes({
  licenceType,
  orderAmount,
  regionalText,
}) {
  let revisedPrice = '';
  const report = useContext(ReportContext);
  const regionalText_2 = useTranslations('buyNow.summary_sec');

  if (orderAmount === report.Price_Multi) {
    revisedPrice = '7,000';
  } else if (orderAmount === report.Price_CUL) {
    revisedPrice = '10,000';
  } else if (orderAmount === report.Price_SUL) {
    revisedPrice = '4,500';
  }
  return (
    <div>
      <div className="flex flex-row justify-between my-1 items-center">
        <div className="space-y-2">
          <p>{regionalText_2('user_license')}:</p>
          {orderAmount != 2000 ? <p>{regionalText_2('std_price')}:</p> : ''}
          {orderAmount != 2000 ? (
            <p>{regionalText_2('disc_price')}:</p>
          ) : (
            <p>{regionalText_2('std_price')}:</p>
          )}
        </div>

        <div className="space-y-2 text-end my-2">
          <p className="fw-normal">{licenceType.replace('License', '')}</p>
          {orderAmount != 2000 ? (
            <p className="text-end text-red-500 font-bold">
              <del>US$ {revisedPrice}</del>
            </p>
          ) : (
            ''
          )}
          <p className="text-green-500 font-bold text-end">
            US$ {orderAmount.toLocaleString()}
          </p>
        </div>
      </div>
      <div className="flex bg-gray-300 justify-between rounded-md px-2">
        <p className="font-semibold my-2 mx-1">{regionalText_2('total')}</p>
        <p className="font-semibold my-2 mx-1">
          US$ {orderAmount.toLocaleString()}
        </p>
      </div>
    </div>
  );
}
